import { createContext, Dispatch, useCallback, useContext, useMemo } from 'react'

import { Actions, ModelState } from './state'

interface Context {
  config: ModelState['config']
  selectedRound: ModelState['selectedRound']
  gameStatus: ModelState['gameStatus']
  updateConfig: (payload: ModelAPI.ConfigurationResponse) => void
  updateSelectedRound: (payload: number) => void
  updateGameStatus: (paylod: API.GameStatus) => void
}

const NotImplemented = () => console.error('Context Method not implemented')

export const ModelContext = createContext<Context>({
  config: undefined,
  selectedRound: 0,
  gameStatus: undefined,
  updateConfig: NotImplemented,
  updateSelectedRound: NotImplemented,
  updateGameStatus: NotImplemented
})

export const useModelContextValue = (state: ModelState, dispatch: Dispatch<Actions>): Context => {
  const updateConfig = useCallback((payload: ModelAPI.ConfigurationResponse) => {
    dispatch({
      type: 'UpdateConfig',
      payload
    })
  }, [dispatch])

  const updateSelectedRound = useCallback((payload: number) => {
    dispatch({
      type: 'UpdateSelectedRound',
      payload
    })
  }, [dispatch])

  const updateGameStatus = useCallback((payload: API.GameStatus) => {
    dispatch({
      type: 'UpdateGameStatus',
      payload
    })
  }, [dispatch])

  const context = useMemo(() => ({
    config: state.config,
    updateConfig,
    selectedRound: state.selectedRound,
    updateSelectedRound,
    gameStatus: state.gameStatus,
    updateGameStatus
  }), [state.config, updateConfig, state.selectedRound, updateSelectedRound, state.gameStatus, updateGameStatus])

  return context
}

export const useModelContext = () => {
  return useContext(ModelContext)
}